import { createContext, useContext } from 'react';

interface UserVerificationContextType {
    isVerifyingUser: boolean;
}

const UserVerificationContext = createContext<UserVerificationContextType>({
    isVerifyingUser: true,
});

export const useUserVerification = () => useContext(UserVerificationContext);

export default UserVerificationContext;
